import { render } from "./PerfilUsuarioPage.vue?vue&type=template&id=69cacfc4"
import script from "./PerfilUsuarioPage.vue?vue&type=script&lang=js"
export * from "./PerfilUsuarioPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__